import React from 'react';

const Topbar: React.FC = () => {

    return (
        <div className="topbar">
            <h1 className='title-topbar'>Github Users Api</h1>
        </div>
    );
}

export default Topbar;